export const GET_ADMIN_ANNOUNCEMENTS = "GET_ADMIN_ANNOUNCEMENTS";

export const SET_ADMIN_ANNOUNCEMENTS = "SET_ADMIN_ANNOUNCEMENTS";

export const ANNOUNCEMENT_CRUD_STATUS = "ANNOUNCEMENT_CRUD_STATUS";

export const GET_FCMDATA = "GET_FCMDATA";

